import { render } from "./StandardForm.vue?vue&type=template&id=3b66785a&scoped=true"
import script from "./StandardForm.vue?vue&type=script&lang=js"
export * from "./StandardForm.vue?vue&type=script&lang=js"

import "./StandardForm.vue?vue&type=style&index=0&id=3b66785a&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b66785a"]])

export default __exports__